import React from 'react';
import Table from '../../../../components/table/Table';
import Button from '../../../../components/Button';
import columns from './columns';
import { SELECTED_COUPON_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/couponConstants';
import { COUPON_SEARCH_MODAL_MODEL } from '../../../../store/modules/coupon/models';
import './CouponGenerateCouponList.scss';

const CouponGenerateCouponList = (props) => {
  const {
    form,
    setData,
    toggleModal,
    selectedCouponIdList,
    issuedCouponList,
    onCheckIssuedCoupon,
    deleteSelectedIssuedCoupon,
  } = props;

  return (
    <div className="coupon-generate-coupon-list">
      <div className="control-list">
        <div className="info">선택한 쿠폰 목록 ({selectedCouponIdList.length})</div>

        <div className="btn-group">
          <Button
            isRadius
            color="primary"
            text="쿠폰 검색"
            onClick={() =>
              toggleModal({
                name: 'searchCouponListModal',
                value: true,
                data: {
                  listData: COUPON_SEARCH_MODAL_MODEL,
                },
              })
            }
          />

          <Button isRadius color="light" text="선택 삭제" onClick={() => deleteSelectedIssuedCoupon()} />
        </div>
      </div>

      <Table
        data={issuedCouponList}
        isStriped={true}
        emptyText={SELECTED_COUPON_LIST_TABLE_EMPTY_TEXT}
        isUsedCheckbox={true}
        checkedIdList={selectedCouponIdList}
        onCheck={(list) => onCheckIssuedCoupon(list)}
        columns={(utils) =>
          columns({
            toggleModal,
            form,
            setData,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default CouponGenerateCouponList;
